import React from 'react';
import { CustomLoadingOutlined, StyledSpinner } from './style';

export const Spiner = () => {
  const antIcon = <CustomLoadingOutlined style={{ fontSize: 45}} rotate={Math.floor(Math.random() * 20)} spin />;
  return <StyledSpinner indicator={antIcon} />;
};
